import React from 'react';
const modules = [{
  title: 'Swim Foundations™',
  description: 'The professional framework for teaching water confidence, body position, breathing, floating, and safety correctly from day one.'
}, {
  title: 'Skill Development Library™',
  description: '150+ swimmer-friendly drills and progressions for every level, from complete beginner to advanced competitive swimmer.'
}, {
  title: 'Lesson Builder System™',
  description: 'Build structured classes in minutes using proven templates, warm-up systems, main sets, and cool-down frameworks.'
}, {
  title: 'Ready-To-Use Lessons™',
  description: 'Complete lessons for kids, adults, beginners, intermediate, and advanced swimmers — ready to teach immediately.'
}, {
  title: 'Season Programs™',
  description: '4-week, 8-week, and 12-week progressions that keep swimmers improving session after session.'
}, {
  title: 'Coaching Mastery™',
  description: 'Teaching cues, error correction, parent communication, student motivation, and class management tools to coach with total confidence.'
}];
export function ModulesSection() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-navy text-white border-y-4 border-brand-pool" data-id="element-106">
      <div className="text-center mb-6" data-id="element-107">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-white mb-2 uppercase leading-tight" data-id="element-108">
          THE SOLUTION YOU'VE BEEN LOOKING FOR — A COMPLETE 6-IN-1 SYSTEM
        </h2>
        <p className="text-sm sm:text-base font-bold text-brand-pool mb-3" data-id="element-109">
          6 professional modules in 1 complete coaching system
        </p>
        <div className="inline-block bg-brand-orange text-white px-3 py-1 rounded mb-3 shadow-sm" data-id="element-110">
          <p className="font-bold text-xs tracking-wide uppercase" data-id="element-111">
            SWIMMING COACH READY™ 6-in-1 Box Set
          </p>
        </div>
        <p className="text-sm text-white/90 leading-snug max-w-xl mx-auto" data-id="element-112">
          SWIMMING COACH READY™ is much more than a collection of drills. It is
          a complete professional operating system designed to help you deliver
          safer, more structured, and more effective swim lessons — for every
          level, every age, and every environment.
        </p>
      </div>

      <div className="flex flex-col gap-3" data-id="element-113">
        {modules.map((module, i) => <div key={i} className="bg-white text-brand-navy p-3.5 rounded-md flex gap-3 items-center shadow-sm" data-id="element-114">
            <div className="text-brand-pool shrink-0 bg-brand-pool/10 w-6 h-6 flex items-center justify-center rounded-full font-bold" data-id="element-115">
              ✅
            </div>
            <div data-id="element-116">
              <h3 className="text-sm font-bold leading-tight mb-0.5" data-id="element-117">
                {module.title}
              </h3>
              <p className="text-brand-navy/80 text-xs leading-snug" data-id="element-118">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}